import type { PdfStudentRiskReportConfig } from '@/domains/export/pdfStudentRiskReport.entity';
import StudentRiskReportDocument from '@/features/academicRisk/components/documents/StudentRiskReportDocument';
import { pdf } from '@react-pdf/renderer';
import { createElement } from 'react';

interface GenerateStudentRiskReportParams {
  config: PdfStudentRiskReportConfig;
  filename?: string;
  logo?: string;
}

export class PdfStudentRiskReportGeneratorService {
  async exportStudentRiskReportToPdf(
    params: GenerateStudentRiskReportParams,
  ): Promise<void> {
    const blob = await this.generateStudentRiskReportBlob(params);
    const filename =
      params.filename || this.generateDefaultFilename(params.config);
    await this.downloadPdf(blob, filename);
  }

  async generateStudentRiskReportBlob(
    params: GenerateStudentRiskReportParams,
  ): Promise<Blob> {
    const pdfElement = createElement(StudentRiskReportDocument, {
      config: params.config,
      logo: params.logo,
    });

    const pdfDocument = pdf(pdfElement);
    return await pdfDocument.toBlob();
  }

  private async downloadPdf(blob: Blob, filename: string): Promise<void> {
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.href = url;
    link.download = filename;
    link.style.display = 'none';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  }

  private generateDefaultFilename(config: PdfStudentRiskReportConfig): string {
    const date = new Date().toISOString().split('T')[0];
    const studentRun = config.studentData.run;
    return `reporte_riesgos_academicos_${studentRun}_${date}.pdf`;
  }
}
